{
    "common": {
        "mon": "Man",
        "tue": "Tir",
        "wed": "Ons",
        "thu": "Tor",
        "fri": "Fre",
        "sat": "Lør",
        "sun": "Søn",
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",        
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Dec",
        "january": "Januar",
        "february": "Februar",
        "march": "Marts",
        "april": "April",
        "may": "Maj",
        "june": "Juni",
        "july": "Juli",
        "august": "August", 
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "December",
        "checkin": "Indtjekning",
        "checkout": "Udtjekning",
        "room": "Værelse",
        "rooms": "Værelser",
        "adult": "Voksen",
        "adults": "Voksne",
        "edit": "Rediger",
        "editCap": "REDIGER",
        "delete": "Slet",
        "deleteCap": "SLET",
        "localTime": "Lokal tid",
        "back": "TILBAGE",
        "home": "HJEM",
        "yes": "JA",
        "no": "NEJ",
        "left": "Tilbage",
        "hour": "Time",
        "hours": "Timer",
        "night": "nat",
        "nights": "nætter",
        "for": "for",
        "why": "Hvorfor",
        "get": "Få",
        "more": "Mere",
        "agree": "ENIG",
        "disagree": "UENIG",
        "basedOn": "baseret på",
        "error": "Der opstod en fejl, prøv venligst igen senere",
        "error2": "Mislykkedes, prøv igen!",
        "error3": "Der opstod en fejl!!",
        "error4": "Der opstod en fejl!! Prøv venligst igen",
        "error5": "Beklager!! Der opstod en fejl. Prøv venligst igen om lidt.",
        "hi": "Hej",
        "to": "til",
        "free": "Gratis",
        "per": "Per",
        "at": "ved",
        "day": "Dag",
        "days": "Dage",
        "time": "Tid",
        "of": "af",
        "photo": "Foto",
        "photos": "Fotos",
        "done": "Færdig",
        "fullStay": "Fuldt ophold",
        "date": "Dato",
        "and": "og",
        "bookingDetail": "Bookingdetalje",
        "Back": "Tilbage",
        "Home": "Hjem"
    },
    "userPopup": {
        "myAccount": "Min konto",
        "welcome": "Velkommen",
        "user": "Bruger",
        "findMyBookings": "FIND MINE BOOKINGER",
        "viewProfile": "SE PROFIL",
        "makeAReservarion": "LAV EN RESERVATION",
        "logout": "LOG UD",
        "loginCap": "LOG IND",
        "login": "Log ind",
        "invalidCredentials": "Ugyldige legitimationsoplysninger",
        "invalidEmail": "Ugyldig e-mail",
        "passwordIsRequired": "Adgangskode er påkrævet",
        "minChar8": "minimum 8 tegn",
        "tooShort": "For kort!",
        "tooLong": "For lang!",
        "required": "Påkrævet",
        "emailInvalid": "Indtast en gyldig e-mail",
        "passwordInvalid": "Indtast en gyldig adgangskode",
        "phNumInvalid": "Telefonnummer er ikke gyldigt",
        "signupCap": "TILMELD",
        "signup": "Tilmeld",
        "verifyText": "Bekræft at det er dig",
        "verifyText2": "Vi sendte en verifikationskode til din e-mail",
        "verificationCode": "Verifikationskode",
        "didNotReceiveEmail": "Modtog ikke e-mail",
        "clickToResend": "Klik for at sende igen",
        "verifyAndSignIn": "Bekræft og log ind",
        "otpSentSuccessfully": "OTP sendt med succes",
        "somethingWentWrong": "Noget gik galt, prøv venligst igen",
        "otpError": "Indtast venligst et gyldigt nummer",
        "otpError2": "Indtast venligst kun tal",
        "otpError3": "Forkert OTP, prøv venligst igen",
        "otpError4": "OTP udløbet, klik Send igen for at prøve igen",
        "otpError5": "Prøv venligst igen",
        "forgetPassword": "Glemt adgangskode",
        "submitError": "Bruger eksisterer ikke!",
        "userExistError": "Bruger eksisterer allerede",
        "checkYourEmail": "Tjek din e-mail",
        "passwordResetLinkSent": "Vi har sendt et link til nulstilling af adgangskode til",
        "noWorriesResetInstructions": "Ingen bekymringer, vi sender dig nulstillingsinstruktioner.",
        "enterYourEmail": "Indtast din e-mail",
        "resetMyPassword": "NULSTIL MIN ADGANGSKODE",
        "setANewPassword": "Indstil en ny adgangskode",
        "newPassword": "Ny adgangskode",
        "confirmPassword": "Bekræft adgangskode",
        "confirmPasswordError": "Adgangskoder skal matche",
        "backToLogin": "Tilbage til login",
        "dontHaveAccount": "Har du ikke en konto?",
        "alreadyHaveAccount": "Har du allerede en konto?",
        "memberDiscount1": "Du får",
        "memberDiscount2": "medlemsrabat for evigt.",
        "discount1": "Administrer alle dine reservationer fra ét sted.",
        "discount2": "Tilmeld dig for personlige anbefalinger og skræddersyede oplevelser!!",
        "discount3": "Bliv medlem af vores fællesskab af glade gæster og begynd at planlægge dit ophold.",
        "leftGridText1": "Administrer alle dine reservationer fra ét sted",
        "leftGridText2": "Tilmeld dig for personlige anbefalinger og skræddersyede oplevelser!!",
        "leftGridText3": "Bliv medlem af vores fællesskab af glade gæster og begynd at planlægge dit ophold",
        "gridDiscountText1": "medlemsrabat på",
        "gridDiscountText2": "udvalgte ejendomme for evigt",
        "gridDiscountText3": "Log ind for en skræddersyet oplevelse for evigt",
        "gridDiscountText4": "Få eksklusive medlemsfordele",
        "findBookingError": "Din e-mail og reservations-id matcher ikke",
        "verifyAndConfirmBooking": "Bekræft og bekræft booking",
        "confirmEmailText": "Vi har sendt en verifikationskode til din e-mailadresse",
        "enterCodeText": "Indtast venligst verifikationskoden sendt til dig",
        "didNotRecieveEmail": "Modtog ikke e-mail?",
        "changeEmailText": "Klik her for at ændre e-mailadressen",
        "verifyAndConfirm": "Bekræft og bekræft",
        "verified": "BEKRÆFTET",
        "bookingExpired": "Booking udløbet",
        "bookingExpiredText": "Vi beklager, det booking-id du bruger er udløbet",
        "backToFindingBooking": "Tilbage til Find booking",
        "findMyBooking": "Find mine bookinger",
        "bookingEmail": "Booking e-mail",
        "reservationId": "Reservations-id",
        "findBooking": "FIND BOOKING",
        "abandonmentCartDoneText1": "Tak!",
        "abandonmentCartDoneText2": "Dine kurvdetaljer er blevet sendt til e-mailen. Fortsæt din booking når som helst.",
        "Recommended Currencies": "Anbefalede valutaer",
        "All currencies": "Alle valutaer",
        "thisIsRequiredField": "Dette er et påkrævet felt"
    },
    "widget": {
        "destination": "Destination",
        "enterDestination": "Indtast destination",
        "guests": "Gæster",
        "guest": "Gæst",
        "nationality": "Nationalitet",
        "selectNationality": "Vælg nationalitet",
        "nationalityIsRequired": "Nationalitet er påkrævet",
        "selectedRate": "Særlig pris",
        "search": "Søg",
        "ages": "Aldre",
        "orAbove": "Eller derover",
        "child": "Barn",
        "children": "Børn",
        "addAnotherRoom": "Tilføj endnu et værelse",
        "removeRoom": "Fjern værelse",
        "property": "Ejendom",
        "city": "By",
        "country": "Land",
        "bookNow": "Book nu",
        "overnightStay": "Overnatning",
        "dayUse": "Dagsbrug",
        "destinationIsRequired": "Destination er påkrævet",
        "checkInIsRequired": "Indtjekningsdato er påkrævet",
        "checkOutIsRequired": "Udtjekningsdato er påkrævet",
        "noLocationFound": "Ingen lokation fundet",
        "soldOut": "Udsolgt",
        "highDemand": "Høj efterspørgsel",
        "dates": "Datoer",
        "allRates": "Alle priser er i",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Samme dag udtjekning"
    },
    "promotion": {
        "headingText": "Vigtig information for",
        "regularRate": "Ingen",
        "seniorCitizen": "Senior borger pris",
        "agencyRate": "Bureau pris",
        "caaRate": "CAA/AAA pris",
        "corporateRate": "Firmapris",
        "governmentRate": "Regerings/militær pris",
        "promotionalSpecialRate": "Kampagne/Special pris",
        "regularRateDescription": "Ingen kampagne anvendt.",
        "seniorCitizenRateDescription": "Dette er en nedsat hotelpris, der i vid udstrækning er tilgængelig for ældre voksne, typisk i alderen 60 eller ældre.",
        "agencyRateDescription": "Dette er en nedsat hotelpris, der kan tilgås gennem specifikke rejsebureauer kun for at fremme partnerskab og samarbejde.",
        "caaRateDescription": "Dette er en særlig hotelpris, der tilbydes medlemmer af AAA eller CAA for eksklusive besparelser.",
        "corporateRateDescription": "Dette er en nedsat hotelpris udvidet til forretningsrejsende, typisk forhandlet mellem hotellet og virksomhedsenheden.",
        "governmentRateDescription": "Denne prisplan tilbyder specifikke rabatter for regerings/militært personale til booking af et hotelværelse.",
        "contentSeniorCitizen": "Fødselsdatobevis er obligatorisk ved indtjekning. Manglende fremlæggelse af relevant ID vil resultere i opkrævning af gældende takster.",
        "contentAgencyRate": "Sørg for at have din bookingbekræftelse og ID-bevis ved ankomst. Manglende fremvisning af disse vil resultere i, at standardpriser anvendes.",
        "contentPromotionalSpecialRate": "Dette er en nedsat hotelpris tilbudt i en begrænset periode, ofte knyttet til specifikke begivenheder, sæsoner eller marketingkampagner.",
        "contentCaaRate": "Sørg venligst for at have dit CAA-medlemskab kort eller relevant identifikation ved indtjekning. Manglende fremlæggelse af relevant ID vil resultere i opkrævning af gældende takster.",
        "contentCorporateRate": "Bevis for firmaets ID eller anden officiel dokumentation er påkrævet ved indtjekning. Manglende fremlæggelse af relevant bevis vil resultere i opkrævning af gældende takster.",
        "contentGovernmentRate": "Gyldigt regerings- eller militær-ID skal fremvises ved indtjekning. Manglende fremlæggelse af den krævede identifikation vil resultere i opkrævning til standardprisen.",
        "CORP": "FIRMA",
        "AGEN": "BUREAU",
        "PROM": "KAMPAGNE",
        "apply": "ANVEND",
        "Offer Code": "Tilbudskode",
        "Agency Code": "Bureau kode",
        "Corporate Code": "Firma kode",
        "All-Access Rate": "Alle-adgangs pris",
        "errorCode": "Denne kode er ikke gyldig"
    }
}